import { css } from '@emotion/core';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
import { tokens, media } from '@domain-group/fe-brary';
export var title = /*#__PURE__*/css("color:", tokens.colors.neutral.heavy.default, ";", designTokenFonts.heading, ";");
export var agentAwards = /*#__PURE__*/css("display:flex;flex-direction:column;margin:32px 0;padding:32px 15px;gap:32px;border-top:1px solid ", tokens.colors.neutral.trim.disabled, ";border-bottom:1px solid ", tokens.colors.neutral.trim.disabled, ";", media('>=tablet'), "{flex-direction:row;gap:10px;}", media('>=desktop'), "{padding-left:0;}");
export var agentAward = {
  name: "17lgwxv",
  styles: "display:flex;flex-direction:row;gap:10px;align-items:center;margin-top:20px;"
};
export var agentAwardCategory = {
  name: "b95f0i",
  styles: "display:flex;flex-direction:column;flex:1;"
};
export var agentAwardLogo = {
  name: "1gapyfo",
  styles: "height:60px;"
};
export var agentAwardContent = {
  name: "j7qwjs",
  styles: "display:flex;flex-direction:column;"
};
export var awardName = /*#__PURE__*/css(designTokenFonts.bodyBold, ";");
export var awardDescription = /*#__PURE__*/css(designTokenFonts.body, ";");
export var awardLink = /*#__PURE__*/css(designTokenFonts.body, ";text-align:left;padding:0;");